"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ColorMap {
    constructor(widthVal, heightVal, resXVal = widthVal, resYVal = heightVal) {
        this.colors = [];
        this.width = widthVal;
        this.height = heightVal;
        this.resX = resXVal;
        this.resY = resYVal;
    }
    put(x, y, paletteIndex) {
        if (!this.isInRange(x, y)) {
            return;
        }
        const rx = this.mapX(x);
        if (this.colors[rx] === undefined) {
            this.colors[rx] = [];
        }
        this.colors[rx][this.mapY(y)] = paletteIndex;
    }
    get(x, y) {
        const mX = this.mapX(x);
        if (this.colors[mX] !== undefined) {
            return this.colors[mX][this.mapY(y)];
        }
        return undefined;
    }
    forEachCell(callback) {
        for (let x = 0; x < this.width; x += this.resX) {
            for (let y = 0; y < this.height; y += this.resY) {
                callback(x, y);
            }
        }
    }
    forEachPixelInCell(x, y, callback) {
        for (let ix = x; ix < x + this.resX; ix += 1) {
            for (let iy = y; iy < y + this.resY; iy += 1) {
                callback(ix, iy);
            }
        }
    }
    isInRange(x, y) {
        return x >= 0 && x < this.width && y >= 0 && y < this.height;
    }
    mapX(x) {
        return Math.floor(x / this.resX);
    }
    mapY(y) {
        return Math.floor(y / this.resY);
    }
}
exports.default = ColorMap;
//# sourceMappingURL=ColorMap.js.map